<div class='row'>

  <div class='col' [formGroup]="addressForm">

    <div class="row form-group" *ngIf="addressForm.controls.FirstName && addressForm.controls.LastName">

      <div class="col-6">
        <label for="FirstName">Vorname*</label>
        <input class="form-control form-control-sm" formControlName="FirstName" required minlength="3">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.FirstName"></form-error>
      </div>

      <div class="col-6">
        <label for="LastName">Nachname*</label>
        <input type="text" class="form-control form-control-sm" formControlName="LastName">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.LastName"></form-error>
      </div>

    </div>

    <div class ="row form-group" *ngIf="addressForm.controls.BranchName">
      <div class="col-6">
        <label for="BranchName">Anschrift Filiale*</label>
        <input type="text" class="form-control form-control-sm" formControlName="BranchName">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.BranchName"></form-error>
      </div>
    </div>

    <div class="row form-group">

      <div class="col-9">
        <label for="Street">Straße*</label>
        <input class="form-control form-control-sm" formControlName="Street" required minlength="3">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.Street"></form-error>
      </div>

      <div class="col-3">
        <label for="StreetNumber">Hausnummer</label>
        <input type="text" class="form-control form-control-sm" formControlName="StreetNumber">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.StreetNumber"></form-error>
      </div>

    </div>

    <div class="row form-group">

      <div class="col-12">
        <label for="AdditionalInformation">Addresszusatz</label>
        <input class="form-control form-control-sm" formControlName="AdditionalInformation">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.AdditionalInformation"></form-error>
      </div>

    </div>

    <div class="row form-group">

      <div class="col-3">
        <label for="ZipCode">Postleitzahl*</label>
        <input class="form-control form-control-sm" formControlName="ZipCode" required minlength="5" maxlength="5">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.ZipCode"></form-error>
      </div>

      <div class="col-9">
        <label for="City">Stadt*</label>
        <input class="form-control form-control-sm" formControlName="City" required minlength="3">
        <form-error [formErrors]="formErrors" [control]="addressForm.controls.City"></form-error>
      </div>

    </div>

  </div>
</div>
